import { fetchBusinessUnits, fetchUsers } from "../../api";
import { ValidationError } from "../../errors";
import { BusinessUnit } from "../../interfaces/BusinessUnit";
import { User } from "../../interfaces/User";
import { loadDataIntoSheet } from "../workbook";

export const tabulateUsers = async (): Promise<void> => {
  try {
    const [usersResult, businessUnitsResult] = await Promise.all([fetchUsers(), fetchBusinessUnits()]);
    if (!usersResult.success) {
      throw usersResult.error;
    }
    if (!businessUnitsResult.success) {
      console.error("Error with Business Units ETL:", businessUnitsResult.error);
    }
    const businessUnitsData: BusinessUnit[] = businessUnitsResult.success ? businessUnitsResult.data || [] : [];
    const businessUnitsMap: Record<string, BusinessUnit> = businessUnitsData.reduce(
      (acc, businessUnit) => {
        acc[businessUnit.id] = businessUnit;
        return acc;
      },
      {} as Record<string, BusinessUnit>
    );

    const usersData: User[] = usersResult.data || [];
    if (!usersData || usersData.length === 0) {
      throw new ValidationError("No users found");
    }
    const filteredUsers = usersData
      .filter((user) => user.source !== "magic_link")
      .map((user) => ({
        ...user,
        business_unit:
          user.business_unit == null ? "" : (businessUnitsMap[user.business_unit]?.name ?? user.business_unit),
      }));
    await loadDataIntoSheet(filteredUsers, "Users", { adminTable: true });
  } catch (error) {
    console.error("Error with Users ETL:", error);
    throw error;
  }
};
